var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "despachos", attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Despachos")])], 1),
      _c("v-divider"),
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          clearable: "",
                          label: _vm.formFields.orden.label,
                          items: _vm.ordenList,
                          "item-text": "despaseguimiento",
                          "item-value": "despaseguimiento"
                        },
                        model: {
                          value: _vm.formFields.orden.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.orden, "value", $$v)
                          },
                          expression: "formFields.orden.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          clearable: "",
                          label: _vm.formFields.tecnico.label,
                          items: _vm.tecnico,
                          "item-text": "tecniconame",
                          "item-value": "tecnicoid"
                        },
                        model: {
                          value: _vm.formFields.tecnico.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.tecnico, "value", $$v)
                          },
                          expression: "formFields.tecnico.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          clearable: "",
                          label: _vm.formFields.coordinador.label,
                          items: _vm.coordinador,
                          "item-text": "coorname",
                          "item-value": "coorid"
                        },
                        model: {
                          value: _vm.formFields.coordinador.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.coordinador, "value", $$v)
                          },
                          expression: "formFields.coordinador.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          clearable: "",
                          label: _vm.formFields.localidad.label,
                          items: _vm.localidad,
                          "item-text": "locaname",
                          "item-value": "locaid"
                        },
                        model: {
                          value: _vm.formFields.localidad.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.localidad, "value", $$v)
                          },
                          expression: "formFields.localidad.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          clearable: "",
                          label: _vm.formFields.courier.label,
                          items: _vm.courrier,
                          "item-text": "configvalor",
                          "item-value": "configid"
                        },
                        model: {
                          value: _vm.formFields.courier.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.courier, "value", $$v)
                          },
                          expression: "formFields.courier.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xm3: "", sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.dateStart.label,
                          "data-vv-name": "fechaInicioRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaInicioRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.dateStart.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateStart, "value", $$v)
                          },
                          expression: "formFields.dateStart.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.dateEnd.label,
                          "data-vv-name": "fechaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaFinRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.dateEnd.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                          },
                          expression: "formFields.dateEnd.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { sm3: "", md3: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.filtrar()
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("search")
                            ]),
                            _vm._v("Filtrar\n            ")
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.clearFilters()
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("clear")
                            ]),
                            _vm._v("Limpiar")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }),
          _c("v-flex", { attrs: { xs12: "", sm4: "", md3: "" } }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md3: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.exportarExcel }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  ),
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: {
                            click: function($event) {
                              _vm.showModalNew = true
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Crear")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card despacho" },
        [
          _c("MantenedorGridSinCodigo", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "auto",
              "font-family": "'Asap', sans-serif"
            },
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showModalNew
        ? _c("FormCrearDespacho", {
            attrs: {
              nuevoCodigo: _vm.valorMax,
              courrierList: _vm.courrier,
              usuarioActivo: _vm.usuarioActivo,
              localidadList: _vm.localidad,
              coordinadorList: _vm.coordinador
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              },
              datoCreado: function($event) {
                return _vm.datoNuevo($event)
              }
            }
          })
        : _vm._e(),
      _vm.showModalEdit
        ? _c("EditarDespacho", {
            attrs: {
              esEdicion: _vm.modalEsEdicion,
              esInformar: _vm.modalEsInformar,
              esDetalles: _vm.modalEsDetalles,
              courrierList: _vm.courrier,
              accion: _vm.editedItem,
              edited: _vm.editedItem,
              localidadList: _vm.localidad,
              coordinadorList: _vm.coordinador,
              usuarioActivo: _vm.usuarioActivo
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              },
              datoEditado: function($event) {
                return _vm.datoEditado($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }